import styled from 'styled-components';
import { InformationCircleOutlineIc } from '@dsch/dd-icons';

export const Text = styled.div`
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  ${({ theme }) => theme.fontSize.B12};
`;
export const SubText = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
  align-items: flex-start;
`;

export const SInformationCircleOutlineIc = styled(InformationCircleOutlineIc)`
  flex: 0 0 auto;
`;
